export default __webpack_public_path__ + "static/media/labeldat1.308ed98f.png";